import { useEffect, useState } from "react";
import axios from "axios";

export default function useRecentCommits(projectId, limit = 50) {
  const [commits, setCommits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    if (!projectId) return;

    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await axios.get(
          `${BACKEND_URL}/projects/${projectId}/commits/recent/`,
          { params: { limit } }
        );

        // backend returns: { recent_commits: [...] }
        const recent = res?.data?.recent_commits || [];

        if (!cancelled) setCommits(recent);
      } catch (e) {
        if (!cancelled) {
          setError(e);
          setCommits([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [projectId, limit, BACKEND_URL]);

  return { commits, loading, error };
}
